var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.80071 0 0 3.756 0 8.4C0 14.7 8.5 24 8.5 24C8.5 24 17 14.7 17 8.4C17 3.756 13.1993 0 8.5 0ZM8.5 11.4C6.82429 11.4 5.46429 10.056 5.46429 8.4C5.46429 6.744 6.82429 5.4 8.5 5.4C10.1757 5.4 11.5357 6.744 11.5357 8.4C11.5357 10.056 10.1757 11.4 8.5 11.4Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;